import { render, staticRenderFns } from "./AddPlayer.vue?vue&type=template&id=0266f94b&"
import script from "./AddPlayer.vue?vue&type=script&lang=js&"
export * from "./AddPlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AddPlayer.vue"
export default component.exports